// const isDev = process.env.NODE_ENV === 'development'
const isDev = false
const productKeys = {
  SWIPE: 'swipeFile',
  DISCOVERY: 'discovery',
  BRIEFS: 'briefs',
  SPYDER: 'spyder',
  LENS: 'lens',
  API: 'api'
}
const PRODUCT_ASSETS = [
  {
    imgUrl: require('../../assets/icons/swipe-file.png'),
    label: 'Swipe File',
    key: productKeys.SWIPE
  },
  {
    imgUrl: require('../../assets/icons/discovery.png'),
    label: 'Discovery',
    key: productKeys.DISCOVERY
  },
  {
    imgUrl: require('../../assets/icons/briefs.png'),
    label: 'Briefs',
    key: productKeys.BRIEFS
  },
  {
    imgUrl: require('../../assets/icons/spyder.png'),
    label: 'Spyder',
    key: productKeys.SPYDER
  },
  {
    imgUrl: require('../../assets/icons/lensIcon.png'),
    label: 'Lens',
    key: productKeys.LENS
  },
  {
    imgUrl: require('../../assets/images/foreplay-api-logo.png'),
    label: 'API Access',
    key: productKeys.API
  }
]
const baseProducts = [productKeys.SWIPE, productKeys.DISCOVERY, productKeys.BRIEFS, productKeys.API]
const PRODUCT_ICON_MAP = PRODUCT_ASSETS.reduce((acc, product) => {
  acc[product.key] = product.imgUrl
  return acc
}, {})

const BASE_PLAN_FEATURES = ['swipe', 'discovery', 'briefs']
const FULL_PLAN_FEATURES = ['spyder', 'lens', 'mcp', 'chrome', 'instagram', ...BASE_PLAN_FEATURES]

const FEATURE_DEFS = {
  swipe: {
    key: 'swipe',
    label: 'Save Organize & Share Ad Ideas',
    productKey: productKeys.SWIPE,
    hover: {
      size: 'lg',
      title: 'Swipe File',
      description: 'Save ads from anywhere using the Chrome Extension or Mobile App to curate & share Pinterest board style ad inspiration.',
      image: require('../../assets/images/products/swipe-show.png')
    }
  },
  discovery: {
    key: 'discovery',
    productKey: productKeys.DISCOVERY,
    labelByPlan: {
      basic_plan: 'Search Ads Database (200M+ Ads)',
      workflow_plan: 'Winning Ads Database (200m Ads)',
      agency_plan: 'Search Ads Database (200m Ads)'
    },
    hover: {
      size: 'lg',
      title: 'Discovery',
      description: 'Search & filter over 200m ads curated by the Foreplay community. Sort by time running, impressions & more.',
      image: require('../../assets/images/products/discovery-show.png')
    }
  },
  briefs: {
    key: 'briefs',
    label: 'Create Sharable Ad Briefs',
    productKey: productKeys.BRIEFS,
    hover: {
      size: 'lg',
      title: 'Briefs',
      description: 'Reverse engineer ad inspiration into a winning brief ready to share.',
      image: require('../../assets/images/products/briefs-show.png')
    }
  },
  spyder: {
    key: 'spyder',
    label: 'Analyze Competitor Ad Libraries',
    productKey: productKeys.SPYDER,
    valueType: 'spyder',
    hover: {
      size: 'lg',
      title: 'Spyder',
      description: 'Track every ad your competitors launch and extract insights and inspiration from their creative strategy.',
      image: require('../../assets/images/products/spyder-show.png')
    }
  },
  lens: {
    key: 'lens',
    label: 'Analyze your ads & build reports',
    productKey: productKeys.LENS,
    valueType: 'lens',
    hover: {
      size: 'lg',
      title: 'Lens',
      description: 'Connect your Meta & TikTok ad accounts to optimize your own ad creative & share customized reports.',
      image: require('../../assets/images/products/lens-show.png')
    }
  },
  mcp: {
    key: 'mcp',
    label: 'Connect to AI Tools',
    icon: 'mcp',
    iconSize: 16,
    hover: {
      size: 'sm',
      title: 'MCP & API',
      description: 'Automate your creative strategy with Claude, ChatGPT and more via MCP or API.',
      image: null
    }
  },
  chrome: {
    key: 'chrome',
    label: 'Chrome Extension',
    icon: require('../../components/globals/Icons/OnboardIcons/ChromeColorIcon.vue').default,
    iconSize: 14,
    hover: {
      size: 'sm',
      title: 'Chrome Extension',
      description: 'Save ads from any platform including Meta Ad Library, Instagram Organic & More.'
    }
  },
  instagram: {
    key: 'instagram',
    label: 'Save ads directly in Instagram',
    icon: 'instagram',
    iconSize: 16,
    hover: {
      size: 'sm',
      title: 'Mobile App',
      description: 'Save & share ad inspiration from your mobile phone.'
    }
  }
}

const getLensFeatureValue = (baseLens) => {
  const count = baseLens || 1
  return count === 1 ? '1 Brand' : `${count}+ Brands`
}

const getPlanFeatures = (planKey, { isMonthly = true, baseLens } = {}) => {
  const plan = SUBSCRIPTION_PLANS.find(item => item.key === planKey)
  if (!plan) return []
  const lensCount = baseLens ?? plan.baseLens
  return (plan.featureKeys || []).map((key) => {
    const def = FEATURE_DEFS[key]
    if (!def) return null
    let value
    if (def.valueType === 'spyder') {
      const spyderCount = plan.baseSpyder?.[isMonthly ? 'monthly' : 'annual']
      // Annual plans use 999 as the "unlimited" sentinel
      value = spyderCount >= 999 ? 'Unlimited' : `${spyderCount} Brand${spyderCount === 1 ? '' : 's'}`
    }
    if (def.valueType === 'lens') value = getLensFeatureValue(lensCount)
    return {
      key: def.key,
      label: def.labelByPlan?.[planKey] || def.label,
      value,
      imgUrl: def.productKey ? PRODUCT_ICON_MAP[def.productKey] : null,
      icon: def.icon || null,
      iconSize: def.iconSize || 16,
      hover: def.hover || null
    }
  }).filter(Boolean)
}

const LEGACY_SUBSCRIPTION_PLANS = [
  {
    key: 'legacy_inspiration_plan',
    tier: 'Legacy Inspiration',
    description: 'For teams of all sizes saving & organizing ad inspiration.',
    baseUserCount: 1
  },
  {
    key: 'legacy_full_workflow_plan',
    tier: 'Legacy Full Workflow',
    description: 'For teams of all sizes saving & organizing ad inspiration.',
    baseUserCount: 2
  }
]

const SUBSCRIPTION_PLANS = [
  {
    key: 'basic_plan',
    tier: 'Basic',
    description: 'Save and organize ad inspiration into shareable boards for beginners & freelancers.',
    price: {
      monthly: 59,
      annual: 49
    },
    annualSavings: 120,
    priceId: {
      monthly: isDev ? 'price_1RLrttAQtq0TW7KZZXUFVcuR' : 'price_1RPEMoAQtq0TW7KZDYBYE0oG',
      annual: isDev ? 'price_1RLruxAQtq0TW7KZAH4QP9ZM' : 'price_1RMEMsAQtq0TW7KZSDalZ3dH'
    },
    includedProducts: baseProducts,
    featureKeys: BASE_PLAN_FEATURES,
    baseUserCount: 1
  },
  {
    key: 'workflow_plan',
    tier: 'Workflow',
    description: 'Analyze competitors and get creative analytics on your own ads',
    isPopular: true,
    price: {
      monthly: 175,
      annual: 149
    },
    annualSavings: 310,
    priceId: {
      monthly: isDev ? 'price_1RLrqCAQtq0TW7KZIU5T0Xc4' : 'price_1RMELcAQtq0TW7KZEgwOHpVQ',
      annual: isDev ? 'price_1RLrsXAQtq0TW7KZse4iZeOD' : 'price_1RMELgAQtq0TW7KZw98seOJy'
    },
    addOns: {
      lens: {
        monthly: { priceId: isDev ? 'price_1RMCDWAQtq0TW7KZm0S41GTK' : 'price_1RMEM4AQtq0TW7KZ0homnuxU', quantity: 1 },
        annual: { priceId: isDev ? 'price_1RMCDyAQtq0TW7KZC9xAvvhd' : 'price_1RiyauAQtq0TW7KZM2Fa9vZl', quantity: 1 }
      },
      spyder: {
        monthly: { priceId: isDev ? 'price_1RLrdWAQtq0TW7KZHOm4TYN8' : 'price_1RMEDUAQtq0TW7KZudgiOTA4', quantity: 10 },
        annual: { priceId: isDev ? 'price_1RLrY7AQtq0TW7KZsBO2rDw4' : 'price_1RMEDSAQtq0TW7KZPC6SVzF4', quantity: 999 }
      }
    },
    includedProducts: [...baseProducts, productKeys.SPYDER, productKeys.LENS],
    featureKeys: FULL_PLAN_FEATURES,
    baseUserCount: 5,
    baseSpyder: {
      monthly: 15,
      annual: 999
    },
    baseLens: 1
  },
  {
    key: 'agency_plan',
    tier: 'Agency',
    description: 'Supercharging marketing groups to scale multiple ad accounts',
    price: {
      monthly: 459,
      annual: 389
    },
    annualSavings: 820,
    priceId: {
      monthly: isDev ? 'price_1RM9wfAQtq0TW7KZYvcvcvwu' : 'price_1RPEL0AQtq0TW7KZRHIntE4x',
      annual: isDev ? 'price_1RLsqMAQtq0TW7KZFlUHbFAf' : 'price_1RMDweAQtq0TW7KZuOKRIR6Z'
    },
    addOns: {
      lens: {
        monthly: { priceId: isDev ? 'price_1RMByYAQtq0TW7KZwkAtFuCn' : 'price_1RPAVaAQtq0TW7KZxMznyOl2', quantity: 10 },
        annual: { priceId: isDev ? 'price_1RLnrcAQtq0TW7KZykH6gJmL' : 'price_1SVewrAQtq0TW7KZLtqVykZ5', quantity: 10 }
      },
      spyder: {
        monthly: { priceId: isDev ? 'price_1RLrdWAQtq0TW7KZHOm4TYN8' : 'price_1RMEDUAQtq0TW7KZudgiOTA4', quantity: 25 },
        annual: { priceId: isDev ? 'price_1RLrY7AQtq0TW7KZsBO2rDw4' : 'price_1RMEDSAQtq0TW7KZPC6SVzF4', quantity: 999 }
      }
    },
    includedProducts: [...baseProducts, productKeys.SPYDER, productKeys.LENS],
    featureKeys: FULL_PLAN_FEATURES,
    baseUserCount: 10,
    baseSpyder: {
      monthly: 50,
      annual: 999
    },
    baseLens: 10
  }
]

const SPYDER_PACKAGES = [
  {
    key: 'spyder_10',
    brandCount: 10,
    monthlyPrice: 99,
    savingsPercent: 0,
    priceId: {
      monthly: 'price_1NpudLAQtq0TW7KZbBqLvDiO'
    }
  },
  {
    key: 'spyder_20',
    brandCount: 20,
    monthlyPrice: 149,
    savingsPercent: 25,
    priceId: {
      monthly: 'price_1Npue6AQtq0TW7KZblNmFnGu'
    }
  },
  {
    key: 'spyder_30',
    brandCount: 30,
    monthlyPrice: 199,
    savingsPercent: 30,
    priceId: {
      monthly: 'price_1NpufDAQtq0TW7KZ6c4ndclX'
    }
  },
  {
    key: 'spyder_50',
    brandCount: 50,
    monthlyPrice: 249,
    savingsPercent: 50,
    priceId: {
      monthly: 'price_1NpuheAQtq0TW7KZpK9e6t06'
    }
  }
]

const GUARANTEE_DETAILS = [
  {
    icon: require('../../components/globals/Icons/MoneyBackIcon.vue').default,
    title: 'Money-back guarantee',
    desc: 'Full refunds within 15 days of purchase'
  },
  {
    icon: require('../../components/globals/Icons/ShieldCancelIcon.vue').default,
    title: 'Cancel Anytime',
    desc: 'No strings attached cancellations'
  },
  {
    icon: require('../../components/globals/Icons/ChatSupportIcon.vue').default,
    title: 'Live Support',
    desc: 'Access support Mon-Fri 6 AM - 5 PM EST.'
  }
]

const ENTERPRISE_BENEFITS = [
  'Unlimited users & product usage',
  'Priority in-app or Slack support',
  'Early access to new features & integrations'
]

const TRUSTED_COMPANIES = [
  'https://publicassets.foreplay.co/trusted-companies/hello-fresh.png',
  'https://publicassets.foreplay.co/trusted-companies/click-funnels.png',
  'https://publicassets.foreplay.co/trusted-companies/true-classic.png',
  'https://publicassets.foreplay.co/trusted-companies/vayner-media.png',
  'https://publicassets.foreplay.co/trusted-companies/canva.png'
]

const SUBSCRIPTION_STATES = {
  INCOMPLETE: 'incomplete',
  INCOMPLETE_EXPIRED: 'incomplete_expired',
  TRIALING: 'trialing',
  ACTIVE: 'active',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
  UNPAID: 'unpaid',
  PAUSED: 'paused',
  NOT_ACTIVE: 'not_active'
}
export {
  ENTERPRISE_BENEFITS,
  GUARANTEE_DETAILS,
  TRUSTED_COMPANIES,
  SUBSCRIPTION_PLANS,
  PRODUCT_ASSETS,
  SUBSCRIPTION_STATES,
  LEGACY_SUBSCRIPTION_PLANS,
  SPYDER_PACKAGES,
  getPlanFeatures
}
